import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { doSendPasswordResetEmail } from '@/firebase/auth';
import { FormBox, FormContent, Title } from './styles';
import useAlertStore from '@/stores/alertStore';
import { LargeTextfield } from '@/components/CustomTextfield/styles';

type ForgotPasswordSchema = {
  email: string;
};

interface ForgotPasswordProps {
  setShowForgotPassword: (value: boolean) => void;
}

const ForgotPassword: FC<ForgotPasswordProps> = ({ setShowForgotPassword }) => {
  const { control, handleSubmit } = useForm<ForgotPasswordSchema>({
    defaultValues: {
      email: '',
    },
  });
  const { showAlert } = useAlertStore();

  const onSubmit: SubmitHandler<ForgotPasswordSchema> = async (data) => {
    try {
      await doSendPasswordResetEmail(data.email);
      showAlert('Password reset email sent!', 'success');
    } catch (error) {
      // Password reset error handled by alert
      showAlert('Failed to send password reset email. Please try again.', 'error');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormBox>
        <FormContent>
          <Stack gap={2}>
            <Stack>
              <Title>Forgot password?</Title>
              <Typography variant="body1" fontWeight="500" color="textSecondary" textAlign="center">
                Don’t worry! It happens. Please enter the email address associated with your account.
              </Typography>
            </Stack>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <LargeTextfield
                  {...field}
                  placeholder="Enter your email address."
                  variant="outlined"
                  fullWidth
                  margin="normal"
                />
              )}
            />
            <Button type="submit" variant="contained" color="primary" fullWidth size="large">
              Submit
            </Button>
            <Button variant="text" color="primary" fullWidth onClick={() => setShowForgotPassword(false)}>
              Back to Log in
            </Button>
          </Stack>
        </FormContent>
      </FormBox>
    </form>
  );
};

export default ForgotPassword;
